<template>
	<div class="grid gap-4">
		<FormKit type="text" name="institution" label="Uitkeringsinstantie" />
		<FormKit
			type="loanlinkDate"
			name="pensionStartDate"
			label="Startdatum (pre-) pensioen"
		/>
		<FormKit
			type="loanlinkDate"
			name="paymentEndDate"
			label="Einddatum uitkering"
		/>
		<FormKit
			type="loanlinkCurrency"
			name="grossYearlyPayment"
			label="Bruto pensioen per jaar"
		/>
		<FormKit
			type="loanlinkPercentage"
			name="percentageCounted"
			label="Percentage meetellen voor toetsinkomen"
		/>
	</div>
</template>
